module.exports = __webpack_public_path__ + "static/media/84763164_474876023189296_1169648731482488832_n.47bf1cc8.jpg";